import React from 'react'
import App from '../components/app'
import Header from '../components/header'
import Footer from '../components/footer'
import Head from 'react-helmet'
import WufooForm from 'react-wufoo-embed'
// import CareersHero from '../components/careersHero'
import CareersSection1 from '../components/careersSection1'
import Wave2 from '../components/wave2'
import Hero from '../components/hero'
import ApplicationForm from '../components/applicationForm'

const Careers = () => {
  return (
    <App>
      <Head>
        <title>Careers | Silver State Pediatric</title>
      </Head>
      <Header />
      <Hero title="Careers" image="https://images.unsplash.com/photo-1563434433168-6bbf17b462b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80" backgroundPosition="center center" />
      <Wave2 />
      <main>
        <CareersSection1 />
        <section>
          <ApplicationForm />
        </section>
        <style jsx>{
          `
          
          `
        }
        </style>
      </main>

      <Footer />
    </App>
  )
}

export default Careers
